import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { checkIfEmailIsVerifiedOrNot } from "../contexts/UserContext";
import { setTitle } from '../helpers/jsHelper';
import { CARD_TYPE } from '../constants/constants';
import { useLocation } from "react-router-dom";
import NoDataContainer from '../common/NoDataContainer.js/NoDataContainer';

export default function CommonGrid({
  title,
  item,
  className,
  subClassName,
  filterArea,
  children,
  hasData,
  topContainer,
  noDataText,
  disableNoDataText,
  noDataAction,
  sticky = true,
  hiddenTab = false,
  style = {}
}) {
  const placeholderRef = useRef(null);
  const [manageHidden, setManageHidden] = useState("hidden")
  const location = useLocation()
  const [headerClass, setHeaderClass] = useState('');
  let scrollPos = 0;

  useEffect(() => {
    setTitle(title);
  }, []);

  useEffect(() => {
    if (placeholderRef?.current && document.body.getBoundingClientRect().top === 0) {
      setManageHidden('hidden')
      setHeaderClass('hidden')
    }
  }, [location.pathname, placeholderRef])
  
  const labels = {
    [CARD_TYPE.PRODUCT_CONFIGURATOR]: 'configurators',
  };

  noDataText = noDataText || `Your ${labels[item] || item || ''} live here!` || `You don't have any ${labels[item] || item || ''}.`;

  const scrollHeaderFixed = () => {
    if (placeholderRef.current && placeholderRef.current.getBoundingClientRect().bottom > 0) {
      setHeaderClass('hidden');
      return;
    }

    const newScrollPos = document.body.getBoundingClientRect().top;
    if (newScrollPos > scrollPos) {
      setHeaderClass('sticky-active');
      setManageHidden("")
    } else {
      setHeaderClass('');
    }
    scrollPos = newScrollPos;
  };

  useEffect(() => {
    if (!sticky) return;

    window.addEventListener('scroll', scrollHeaderFixed);

    return () => window.removeEventListener('scroll', scrollHeaderFixed);
  }, []);

  return (
    <div className={`w-100 main-container ${subClassName || ''} ${className || ''} ${!checkIfEmailIsVerifiedOrNot(false) ? 'bottom-space' : ""}`} id="body" style={style}>
      <header id="pageHeader" className={`pageHeader static`} ref={placeholderRef}>
        {topContainer}
        {filterArea}
      </header>
      {
        sticky && 
        <header className={`pageHeader sticky ${hiddenTab ? "tab-none" : ""} ${headerClass !== manageHidden ? manageHidden : ""} ${headerClass || ''}`}>
          {topContainer}
          {filterArea}
        </header>
      }
      {children}
      {!hasData && !disableNoDataText && (
        <>
          <NoDataContainer title={noDataText} actionBtn={noDataAction}/>
        </>
      )}
    </div>
  );
}
